import React from "react";

import LoadingSpinner from "../LoadingSpinner";
import DBListPager from "../db-list/DBListPager";

import styles from "./ListContentWrapper.module.scss";
import FormInput from "../forms/FormInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  displayCount: string;
  totalEntries: number;
  handleStatus?: (status: string) => void;
  handlePeriod?: (period: string) => void;
  handleCategory?: (category: string) => void;
  handleAccountType?: (accountType: string) => void;
  currentPage: number;
  totalPage: number;
  isLoading: boolean;
  status?: string | string[];
  period?: string;
  category?: string;
  categoryOptions?: Array<[string, string]>;
  accountType?: string;

  children: React.ReactNode;
  optionalComponent?: React.ReactNode;
  iSCourse?: boolean;
};

const ListContentWrapper: React.FC<Props> = ({
  displayCount,
  totalEntries,
  handleStatus,
  handlePeriod,
  handleCategory,
  handleAccountType,
  currentPage,
  totalPage,
  isLoading,
  status,
  period,
  category,
  categoryOptions,
  accountType,
  children,
  optionalComponent,
  iSCourse,
}) => {
  return (
    <div className={styles["c-listContentWrapper"]}>
      {optionalComponent && optionalComponent}
      {isLoading ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <>
          <div
            className={`${styles["c-listContentWrapper__info"]} ${styles["top"]}`}
          >
            <div
              className={styles["c-listContentWrapper__info-count"]}
            >{`${displayCount}/${totalEntries}件`}</div>
            <div className={styles["c-listContentWrapper__info-sort__wrapper"]}>
              {handleAccountType ? (
                <div>
                  <span
                    className={styles["c-listContentWrapper__info-sort__ttl"]}
                  >
                    アカウントタイプ
                  </span>
                  <div className={styles["c-listContentWrapper__info-sort"]}>
                    <FormInput
                      type="select"
                      name="sort_account_type"
                      label=""
                      handler={(value: string | File | undefined) => {
                        if (typeof value === "string") {
                          handleAccountType(value);
                        }
                      }}
                      options={[
                        ["default", "全ユーザー"],
                        ["jikei", "滋慶アカウントのみ"],
                        ["select", "滋慶アカウントを除く"],
                      ]}
                      initial_value={accountType ? accountType : "default"}
                    />
                    <FontAwesomeIcon icon={["fal", "chevron-down"]} />
                  </div>
                </div>
              ) : null}
              {handlePeriod ? (
                <div>
                  <span
                    className={styles["c-listContentWrapper__info-sort__ttl"]}
                  >
                    掲載ステータス
                  </span>
                  <div className={styles["c-listContentWrapper__info-sort"]}>
                    <FormInput
                      type="select"
                      name="sort_publishing_period"
                      label=""
                      handler={(value: string | File | undefined) => {
                        if (typeof value === "string") {
                          handlePeriod(value);
                        }
                      }}
                      options={[
                        ["default", "全期間"],
                        ["now", "期間中"],
                        ["future", "掲載期間前"],
                        ["end", "掲載期間終了"],
                      ]}
                      initial_value={period ? period : "default"}
                    />
                    <FontAwesomeIcon icon={["fal", "chevron-down"]} />
                  </div>
                </div>
              ) : null}
              {handleStatus ? (
                <div>
                  <span
                    className={styles["c-listContentWrapper__info-sort__ttl"]}
                  >
                    審査ステータス
                  </span>
                  <div className={styles["c-listContentWrapper__info-sort"]}>
                    <FormInput
                      type="select"
                      name="sort_status"
                      label=""
                      handler={(value: string | File | undefined) => {
                        if (typeof value === "string") {
                          handleStatus(value);
                        }
                      }}
                      options={[
                        ["all", "全て"],
                        ["PUBLICLY_VISIBLE", "公開"],
                        ["AWAITING_INSPECTION", "審査中"],
                        ["NOT_PUBLICLY_VISIBLE", "非公開"],
                        ["default", "非公開以外"],
                      ]}
                      initial_value={
                        !status?.length
                          ? undefined
                          : status.length === 2
                          ? "default"
                          : status[0]
                      }
                    />
                    <FontAwesomeIcon icon={["fal", "chevron-down"]} />
                  </div>
                </div>
              ) : null}
              {handleCategory && categoryOptions ? (
                <div>
                  <span
                    className={styles["c-listContentWrapper__info-sort__ttl"]}
                  >
                    {iSCourse ? `コース名` : `カテゴリー`}
                  </span>

                  <div className={styles["c-listContentWrapper__info-sort"]}>
                    <FormInput
                      type="select"
                      name="sort_category"
                      label=""
                      handler={(value: string | File | undefined) => {
                        if (typeof value === "string") {
                          handleCategory(value);
                        }
                      }}
                      options={categoryOptions}
                      initial_value={category ? category : "default"}
                    />
                    <FontAwesomeIcon icon={["fal", "chevron-down"]} />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {children}
          <div
            className={`${styles["c-listContentWrapper__info"]} ${styles["bottom"]}`}
          >
            <div
              className={styles["c-listContentWrapper__info-count"]}
            >{`${displayCount}/${totalEntries}件`}</div>
            <DBListPager totalPage={totalPage} currentPage={currentPage} />
          </div>
        </>
      )}
    </div>
  );
};

export default ListContentWrapper;
